module.exports = __webpack_public_path__ + "img/17a001-09.99bc25bb.jpg";